import AccidentDashboard from "./accidentDashboard";

const AccidentDashboardContainer = ({ setDisplayAccidents }) => {
  return <AccidentDashboard setDisplayAccidents={setDisplayAccidents} />;
};

export default AccidentDashboardContainer;